import { createAction } from '@reduxjs/toolkit';

import {
  LOAD_CLAIM_INFO_BY_ORDER,
  LOAD_MARKETPLACE_CAPABILITIES_BY_SELLER,
  LOAD_MARKETPLACE_TICKETS_BY_ORDER,
  LOAD_OWNER_PRODUCTS,
} from './actionTypes';

export const loadClaimInfoByOrder = createAction<{
  orderId: string;
  ownerId: string;
}>(LOAD_CLAIM_INFO_BY_ORDER.BASE);

export const loadOwnerProducts = createAction(LOAD_OWNER_PRODUCTS.BASE);
export const loadMarketplaceTicketsByOrder = createAction(
  LOAD_MARKETPLACE_TICKETS_BY_ORDER.BASE,
);
export const loadMarketplaceCapabilitiesBySeller = createAction(
  LOAD_MARKETPLACE_CAPABILITIES_BY_SELLER.BASE,
);
